import EBarSCOAnnouncementsCTA from './EBarSCOAnnouncementsCTA';

export default EBarSCOAnnouncementsCTA;
